// extracted by mini-css-extract-plugin
export default {"Video":"AutoPlayVideo-module__Video__wOWxKwf","PlayButton":"AutoPlayVideo-module__PlayButton__CfT6cGP"};